module.exports = __webpack_public_path__ + "img/order_empty.1fdc9a3d.png";